<script lang="ts">
	import { Accordion as AccordionPrimitive, type WithoutChild } from 'bits-ui'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithoutChild<AccordionPrimitive.ContentProps> = $props()
</script>

<AccordionPrimitive.Content
	class="data-open:animate-accordion-down data-closed:animate-accordion-up overflow-hidden text-sm"
	data-slot="accordion-content"
	bind:ref
	{...restProps}
>
	<div
		class={cn(
			'[&_a]:hover:text-foreground pt-0 pb-2.5 [&_a]:underline [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4',
			className
		)}
	>
		{@render children?.()}
	</div>
</AccordionPrimitive.Content>
